import { Box, Button, Grid, InputLabelProps, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { ImageUpload } from '../../components/ImageUpload';
import { AB_TEST_TARGET_TYPE, IDisplayVariant } from '../../services/types';
import { uploadFile } from '../../services/api/S3';
import useStyles from './styles';

interface IDisplayVariantProps {
  variant: IDisplayVariant;
  testTargetType: AB_TEST_TARGET_TYPE | '';
  onChangeVariantProp: (k: any, v: any) => void;
  removeVariant: () => void;
  editable: boolean;
}
const DefaultImage = `featured/collection_default_banner.png`;

const DisplayVariant = (props: IDisplayVariantProps): JSX.Element => {
  const classes = useStyles();
  const { testTargetType, editable, variant, onChangeVariantProp, removeVariant } = props;
  const inputLabelProps: InputLabelProps = { shrink: true, classes: { root: classes.inputLabel } };
  const [pendingUploadV, setPendingUploadV] = useState<boolean>();
  const [pendingUploadH, setPendingUploadH] = useState<boolean>();

  const onFileUpload = async (propName: string, file: File, blob: Blob, imageContent: string, fileExt?: string) => {
    if (!fileExt) {
      alert('not supported file');
      return;
    }

    try {
      propName === 'additionalCoverVUrl' ? setPendingUploadV(true) : setPendingUploadH(true);
      const result = await uploadFile(`${propName}.${fileExt}`, blob);

      if (result?.data && result?.status === 200) {
        onChangeVariantProp(propName, result.data.url);
      }
    } catch (e) {
      console.error(e);
    } finally {
      propName === 'additionalCoverVUrl' ? setPendingUploadV(false) : setPendingUploadH(false);
    }
  };

  return (
    <Paper className={classes.variantPaper}>
      {editable && (
        <Box display="flex" flexDirection="row" alignItems="center" paddingBottom={2}>
          <Grid container></Grid>
          <Button color="secondary" size="small" variant="outlined" onClick={removeVariant} disabled={!editable}>
            <i className="material-icons">delete</i>
          </Button>
        </Box>
      )}
      <Grid container spacing={2}>
        {variant.id && (
          <Grid item xs={12}>
            ID: {variant.id}
          </Grid>
        )}
        <Grid item xs={12}>
          <TextField
            label={'Title'}
            fullWidth
            value={variant.data?.title}
            onChange={e => {
              onChangeVariantProp('title', e.target.value);
            }}
            disabled={!editable}
            InputLabelProps={inputLabelProps}
          />
        </Grid>
        {testTargetType === AB_TEST_TARGET_TYPE.SEASON && (
          <React.Fragment>
            <Grid item xs={12}>
              <TextField
                label={'Summary'}
                fullWidth
                value={variant.data?.summary}
                onChange={e => {
                  onChangeVariantProp('summary', e.target.value);
                }}
                disabled={!editable}
                InputLabelProps={inputLabelProps}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'Tagline'}
                fullWidth
                value={variant.data?.tagLine}
                onChange={e => {
                  onChangeVariantProp('tagLine', e.target.value);
                }}
                disabled={!editable}
                InputLabelProps={inputLabelProps}
              />
            </Grid>
          </React.Fragment>
        )}
        <Grid item xs={6}>
          <div>Cover Image</div>
          <ImageUpload
            onFileLoaded={(file: File, blob: Blob, imageContent: string, fileExt?: string) =>
              onFileUpload('additionalCoverVUrl', file, blob, imageContent, fileExt)
            }
            src={variant.data?.additionalCoverVUrl || DefaultImage}
            readonly={!editable}
            isPending={pendingUploadV}
          />
        </Grid>
        <Grid item xs={6}>
          <div>Featured Image</div>
          <ImageUpload
            onFileLoaded={(file: File, blob: Blob, imageContent: string, fileExt?: string) =>
              onFileUpload('additionalCoverHUrl', file, blob, imageContent, fileExt)
            }
            src={variant.data?.additionalCoverHUrl || DefaultImage}
            readonly={!editable}
            isPending={pendingUploadH}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DisplayVariant;
